import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'dmmp-button-filter',
  templateUrl: './button-filter.component.html'
})
export class ButtonFilterComponent implements OnInit {

  @Input() module
  @Input() identifier
  @Input() defaultClass = 'button-filter'
  @Output() filtersState = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

}
